import React from 'react';
import {Row, Col, Panel} from 'react-bootstrap';
import Block from './Block'
import BmcBlockIcon from '../common_components/bmc/BmcBlockIcon';
import {injectIntl} from 'react-intl';
import SuggestBlock from "./SuggestBlock";


class StepByStepFormBlock extends React.Component {
    constructor(props) {
        super(props);


        this.state = {}
    }

    render() {
        const {blockStore, formComponent, children, title} = this.props;
        return (
            <div className="container ">
                <Row className="no-padding-xs">

                    <Col xs={12} className="no-padding-xs">
                        <div className={'interactive-form-block-title'}>
                            <span className="bold interactive-bold-title">
                                <BmcBlockIcon block={blockStore.name}/>&nbsp;
                                {this.props.intl.formatMessage({id: "IgbmcBoard-" + blockStore.name})}:&nbsp;&nbsp;
                            </span>
                            {title}
                        </div>
                    </Col>

                    <Col xs={12} md={8} className="no-padding-xs">
                        <Panel className="border-top-6">
                            {children}
                            <div style={{paddingBottom: '10px'}}/>
                        </Panel>
                        <br/>
                    </Col>

                    <Col xs={12} md={4} className="no-padding-xs">
                        <Block blockStore={blockStore} hideBlockAction={true}/>
                        <br/>

                        <SuggestBlock blockStore={blockStore}/>

                    </Col>
                </Row>
            </div>
        );
    }
}


export default injectIntl(StepByStepFormBlock);